import { render } from "./PhysicalNetworksTab.vue?vue&type=template&id=1cc414f8&scoped=true"
import script from "./PhysicalNetworksTab.vue?vue&type=script&lang=js"
export * from "./PhysicalNetworksTab.vue?vue&type=script&lang=js"

import "./PhysicalNetworksTab.vue?vue&type=style&index=0&id=1cc414f8&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc414f8"]])

export default __exports__